module.exports = __webpack_public_path__ + "static/img/logoNEW_1.e941a00.png";


//////////////////
// WEBPACK FOOTER
// ./static/Brand/Main/logoNEW_1.png
// module id = 1152
// module chunks = 18